import { Status } from "../../models/Status";
import { createAction } from "../../models/Action";
import { showMessageBox } from "../MessageBox/actions";
import history from "../../utils/history";
import * as T from "./types";
import { Auth } from "../../utils/auth";
import { weAreOnNuRealityDomain } from "../../shared";

export const signUp = (values: any) => {
  return async (dispatch) => {
    try {
      dispatch(createAction(T.SIGN_UP_STATUS, Status.createLoading()));
      const result = await (
        await Auth()
      ).signUp({
        username: values.username,
        password: values.password,
        attributes: {
          "custom:company": values.company,
          email: values.username,
          given_name: values.givenName,
          website: values.website || "",
          family_name: values.familyName,
          "custom:news_letter": values.sendNewsletter,
          "custom:country": values.country,
        },
      });
      dispatch(createAction(T.SIGN_UP_STATUS, Status.createSuccess()));
      dispatch(createAction(T.SIGN_UP_USER, result));
      history.push("/confirm-account" + window.location.search);
    } catch (e: unknown) {
      let msg = "An unknown error has occurred";
      let code = "Unknown";
      if ((e instanceof Error || typeof e === "object") && e) {
        msg = (e as Record<string, unknown>).message as string;
        code = (e as Record<string, unknown>).code as string;
      }
      // Special case: Extend the server's "An account with the given email already exists." message
      if (code === "UsernameExistsException")
        msg += weAreOnNuRealityDomain
          ? " Please log in with your nuScenes account."
          : " Please log in with your nuReality account.";

      dispatch(createAction(T.SIGN_UP_STATUS, Status.createFailed(msg)));
      dispatch(showMessageBox(msg));
    }
  };
};

export const resetStatus = () => {
  return (dispatch) => {
    dispatch(createAction(T.SIGN_UP_STATUS, new Status()));
    dispatch(createAction(T.SIGN_UP_USER, {}));
  };
};
